export default __webpack_public_path__ + "static/media/landing_1.cf28798a.jpg";